export default __webpack_public_path__ + "static/media/forgot.2d287438.svg";